/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProcessResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class ProcessPublicController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Fetch all processes
   *
   * @tags process-public-controller
   * @name FindAll
   * @request GET:/api/v1/process
   */
  findAll = (params: RequestParams = {}) =>
    this.request<ProcessResponse[], any>({
      path: `/api/v1/process`,
      method: "GET",
      ...params,
    });
}
